import { render, staticRenderFns } from "./CreateGoogleAccount.vue?vue&type=template&id=2cccc284"
import script from "./CreateGoogleAccount.vue?vue&type=script&lang=js"
export * from "./CreateGoogleAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateGoogleAccount.vue?vue&type=style&index=0&id=2cccc284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports